import { getAuthUrl } from '../../utils/config';

export function clearLocalUserData() {
  localStorage.removeItem('greentech_roleType');
  localStorage.removeItem('greentech_mtUid');
}

export function getLocalUserData() {
  const roleType = localStorage.getItem('roleType');
  const mtUid = localStorage.getItem('mtUid');
  const userName = localStorage.getItem('userName');
  const sign = localStorage.getItem('sign');
  const pageType = localStorage.getItem('pageType');
  if ([undefined, null, 'undefined', 'null', '', ' '].includes(mtUid)) {
    return { roleType: undefined, mtUid: undefined };
  }
  if (Number.isNaN(Number(roleType))) {
    return { roleType: undefined, mtUid: undefined };
  }
  return {
    roleType, mtUid, userName, sign, pageType,
  };
}

export function clearUserData() {
  localStorage.removeItem('roleType');
  localStorage.removeItem('mtUid');
  localStorage.removeItem('pageType');
  localStorage.removeItem('userName');
  localStorage.removeItem('sign');
  localStorage.removeItem('signSci');
  localStorage.removeItem('signIno');
  localStorage.removeItem('phone');
}

export function setUserData({
  mtUid, roleType, userName, sign, phone, signSci, signIno,
}) {
  const { mtUid: preId } = getLocalUserData();
  if (String(preId) !== String(mtUid)) {
    clearUserData();
  }
  localStorage.setItem('roleType', String(roleType));
  localStorage.setItem('mtUid', String(mtUid));
  localStorage.setItem('userName', String(userName));
  localStorage.setItem('sign', String(sign));
  localStorage.setItem('signSci', String(signSci));
  localStorage.setItem('signIno', String(signIno));
  localStorage.setItem('phone', String(phone));
}

export function userLogout() {
  const { logOutUrl } = getAuthUrl();
  window.location.href = logOutUrl;
  clearLocalUserData();
}
